import CardLayeredFooter from '@liquidweb-dev/undercurrent/CardLayeredFooter';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import Typography from '@liquidweb-dev/undercurrent/Typography';

import HookedTextField from 'components/standard/Form/HookedTextField';

const ConfirmFooter = () => (
	<CardLayeredFooter
		sx={(theme) => ({
			position: 'relative',
			backgroundColor: theme.vars.palette.uc.danger.bg.main,
			marginTop: -150,
			paddingTop: 300,
			paddingBottom: 200,
			zIndex: 0,
		})}
	>
		<Stack width="100%" gap={150}>
			<Typography variant="label-lg" fontWeight={500}>
				To verify, type{' '}
				<Typography variant="label-lg" fontWeight={700}>
					CONTINUE
				</Typography>{' '}
				below
			</Typography>
			<HookedTextField
				name="verification_text"
				placeholder="CONTINUE"
				autoComplete="off"
				fullWidth
			/>
		</Stack>
	</CardLayeredFooter>
);

export default ConfirmFooter;
